import axios from 'axios';

export class HttpClient {
  /**
   * The headers to include by default in each request.
   */
  defaultHeaders = {};

  /**
   * Remote calls cache.
   * @type HttpRemoteCallsCache
   */
  remoteCallsCache;

  constructor(remoteCallsCache) {
    this.remoteCallsCache = remoteCallsCache;
  }

  /**
   * Executes the remote call and return a promise that resolves with
   * the remote call response or rejects with the resulting error.
   * @param {HttpRemoteCall} remoteCall
   * @returns {Promise}
   */
  execute(remoteCall) {
    const headers = remoteCall.getHeaders();
    const body = remoteCall.getBody();
    const params = remoteCall.getQuery();

    const { method, withCredentials, responseType } = remoteCall;

    const url = remoteCall.fullPath;

    return axios({
      method,
      url,
      responseType,
      withCredentials,
      params,
      headers: {
        ...this.defaultHeaders,
        ...headers
      },
      data: body
    }).then((response) =>
      remoteCall.responseParser ? remoteCall.responseParser.parse(response) : response
    );
  }
}
